export const clientId = "40344979493-q9pql7u48m43hibssn4pc8mdkmc5alh9.apps.googleusercontent.com"
export const secretKey = "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\n"
